import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
/** Sidebar block layout id 1 */ const DeviationGrid3X3 = ({ block , deviation: parentDeviation  })=>{
    var _block_deviations;
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block
    }, /*#__PURE__*/ React.createElement(DeviationSidebarGrid, {
        streamId: `sidebar-3x3-${block.contentType}`,
        deviations: (_block_deviations = block.deviations) !== null && _block_deviations !== void 0 ? _block_deviations : [],
        parentDeviation: parentDeviation,
        maxRows: 3
    }));
};
DeviationGrid3X3.displayName = 'DeviationGrid3X3';
export default DeviationGrid3X3;
